// extracted by mini-css-extract-plugin
export default {"follow":"follow_LhAAm"};